export default __webpack_public_path__ + "static/media/info-circle.d3d41f1b.svg";